import { ReactElement, useContext } from "react";
import { AuthContext, AuthStatus } from "../contexts/AuthContext";
import { IntercomWrapper } from "./IntercomWrapper";

export function IntercomWrapperRegular(props: {children: ReactElement | ReactElement[]}): ReactElement {
    const {user, authStatus} = useContext(AuthContext);
    return <IntercomWrapper user={authStatus === AuthStatus.SignedIn ? user : null} {...props}/>;
}